import request from '../../libs/request';

export default {
  bestFreightsOptions: (sku, cep, siteId) => request(`${siteId}/frete/${sku}/${cep}`, 'ocean').get(),

  getFreights: (id, queryParams, siteId) => request(`${siteId}/frete/carrinho/${id}`, 'ocean').get({ queryParams }),
};
